import type { FC, PropsWithChildren } from "react";
import React from "react";
import styles from "./UpholsterySkeleton.module.scss";

const UpholsterySkeleton: FC<PropsWithChildren<{ loading: boolean }>> = (props): JSX.Element => {
    const { loading, children } = props;

    return loading ? (
        <div className={styles["skeleton-wrapper"]}>
            <div className={styles["skeleton-header"]}>
                <div className={styles.loadbar} style={{ width: "100px" }} />
                <div className={styles.loadbar} style={{ width: "80px" }} />
            </div>
            <div className={styles["swatch-loader"]} />
        </div>
    ) : (
        <>{children}</>
    );
};

export default UpholsterySkeleton;
